/**
 * Created by Alan Yang on 7/22/2018
 * Description:
 *
 * ---------maintenance history-------------
 * 05/18/2019   Bowen Li    modified the func on ipad: user need to touch twich to direct appointed page
 * 06/26/2019   Yoyo Fang   js control subitems show/hide. delay show/hide for mouse quiclkly move like 1->2->1.1.
 * 07/02/2019   Bowen Li    navigation can not be open when click on ipad
 * 08/01/2019   Bowen Li    remove ElementRef
 * 06/26/2019   Yoyo Fang   before navigation starts clean up sub chrome
 * 12/05/2019   Yoyo Fang   instead of watch for ngrx store screenInfo change to update selectedMenu, watch at route url
 * 09/10/2020   Ella Ma     add workflow menu
 * 01/12/2022   Daniel Wang move email diget from setting page
 */
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { NavigationMenu } from './navigation-menu.model';
import { AppState } from '../../redux';
import { Subscription } from 'rxjs/Subscription';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StoreQuerierService } from '../../services/store-querier.service';
import { visibleScreensSelector, systemCurrentContactSelector } from '../../redux/reducers/system.reducer';
import { DashboardDialogService } from '../dashboard/dashboard-dialog/dashboard-dialog.service';
import { MENU_TOLERANCE } from '../../tamalelibs/constants/business.constants';
import { businessConstants } from '../../constants/business.constants';
import { SaveScreenDialogService } from '../save-screen-dialog/save-screen-dialog.service';
import { SaveScreenDialogOperations, SaveScreenDialogType, SaveScreenDialogInvoker } from '../save-screen-dialog/save-screen-dialog.view-model';
import { ResearchViewInfo } from '../../pages/research/research.view-model';
import { ResearchFocusStatus } from '../finder/finder.view-model';
import { ScreenActionTypes } from '../../redux/actions/screen.actions';
import { filter, skip } from 'rxjs/operators';
import { BriefConfig } from '../../widgets/widgets.model';
import { SlideSheetTempService } from '../../services/slide-sheet-temp.service';
import { Subject } from 'rxjs';
import { IntralinksAccountDialogService } from '../intralinks-account-dialog/intralinks-account-dialog.service';
import { IntralinksAccountDialogOpenParam, IntralinksAccountDialogOperations } from '../intralinks-account-dialog/intralinks-account-dialog.view-model';
import { SystemUser } from '../../tamalelibs/models/user.model';
import { WorkflowDialogService } from '../../pages/workflow/workflow-dialog/workflow-dialog.service';
import { ToastService } from '../../widgets/toast/toast.service';
import { NotificationOptions, NotificationStyles } from '../../widgets/notification/notification.model';
import { IntralinksSetting, SystemConfig } from '../../models/global-setting';
import { ArrayHelperService } from '../../tamalelibs/services/array-helper.service';

@Component({
    selector: 'navigation-menu',
    templateUrl: './navigation-menu.component.html',
    styleUrls: ['./navigation-menu.component.scss']
})
export class NavigationMenuComponent implements OnInit, OnDestroy {
    @Input() config: BriefConfig;

    navigationMenuContainer: NavigationMenu[];
    selectedMenu = 'home';
    currentLivewireName: string;
    isIPAD = false;
    hideIntralinks = false;
    hoverMenu: string = null;
    isNavigationCollapse = true; // expand or collapse the navigation when mouseover/click event
    isNavigationDataReady = false;
    isLivewireDataReady = false;
    eventSubject$ = new Subject<any>();
    canCreateWorkflow = false;

    private _currentUser: SystemUser;
    private _destroySubscriptions: Array<Subscription> = [];
    private _showAudit = false;
    private _delayDismiss: any = null;
    private _isAdminUser = false;
    private _isPublishPubConfiguration = false;

    constructor(
        private _router: Router,
        private _deviceService: DeviceDetectorService,
        private _store: Store<AppState>,
        private _storeQuerierService: StoreQuerierService,
        private _DashboardDialogService: DashboardDialogService,
        private _workflowDialogService: WorkflowDialogService,
        private _saveScreenDialogService: SaveScreenDialogService,
        private _tempSlideSheet: SlideSheetTempService,
        private _intralinkAccountDialogService: IntralinksAccountDialogService,
        private _toastService: ToastService
    ) {
        this.isIPAD = this._deviceService.isMobile() || this._deviceService.isTablet();
    }

    ngOnInit() {
        this._currentUser = this._storeQuerierService.getCurrentUser();
        const user = this._storeQuerierService.getCurrentUser();
        this._showAudit = !!user.credential.compliance;
        this._isPublishPubConfiguration = !!user.credential.publishPubConfiguration;
        this._isAdminUser = !!user.credential.admin;
        this.canCreateWorkflow = this._isPublishPubConfiguration && this._isAdminUser;

        // create the navigation menu
        this._createNavigationMenu();
        this._destroySubscriptions.push(
            this._store.pipe(
                select(visibleScreensSelector),
                filter(item => !!item),
            ).subscribe(items => {
                this._loadMoreData(items);
            }),

            this._store.pipe(
                select('subChromeName'),
                filter(item => !!item),
            ).subscribe(value => this._changeLivewireName(value)),

            this._store.pipe(
                select('screenInfo'),
                filter(item => !!item.screenType),
            ).subscribe(screenInfo => {
                if (screenInfo.length !== 0) {
                    this._setSelectedMenu(screenInfo.screenType);
                }
            }),

            this._router.events.pipe(
                filter((val) => val instanceof NavigationEnd)
            ).subscribe((val: NavigationEnd) => {
                this._mapUrl2SelectedMenu(val.url);
            }),
            this.eventSubject$.subscribe((event) => {
                if (event.type === 'click' && event.payload && event.payload.id === 'intralink_add') {
                    this._intralinkAccountDialogService.open({
                        operation: IntralinksAccountDialogOperations.CREATE,
                        data: null
                    } as IntralinksAccountDialogOpenParam);
                } else {
                    if (event.payload.routerLink) {
                        this._cleanPageInfo(null);
                        this.isNavigationCollapse = true;
                    }
                }
            }),
            this._store.pipe(
                select('systemConfig'),
                filter(item => !!item),
                skip(1),
            ).subscribe((systemConfig: SystemConfig) => {
                const triggerType = systemConfig.triggerType;
                if (triggerType === businessConstants.globalConfig.workflow) {
                    this._onWorkflowConfigChange(systemConfig.workflow);
                } else if (triggerType === businessConstants.globalConfig.intralinks) {
                    const isOnlyEnable = systemConfig['isOnlyEnable'];
                    this._onIntralinksConfigChange(systemConfig.intralinks, isOnlyEnable);
                }
            }),
        );
        this._mapUrl2SelectedMenu(this._router.url);
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    // stop propagation
    emptyClick($event) {
        if ($event.preventDefault) {
            $event.preventDefault();
        }
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
        this._tempSlideSheet.actionSubject$.next('');
    }

    goHome(event) {
        this._router.navigate(['home']);
    }

    // when user click the menu
    itemOnClick(event, item) {
        if (item === 'settings') {
            this.emptyClick(event);
            if (!this.isIPAD) {
                this._setSelectedMenu(item);
                this._cleanPageInfo(item);
                this._router.navigate(['settings/screens']);
                this.isNavigationCollapse = true;
            }
        } else if (item.routerLink) {
            this.emptyClick(event);
            this._setSelectedMenu(item.type);
            this._cleanPageInfo(item.routerLink);
            this._router.navigate([item.routerLink]);
            this.isNavigationCollapse = true;
        } else {
            this.isNavigationCollapse = false;
        }
    }

    placeholderOnMouseOver($event) {
        if ($event.preventDefault) {
            $event.preventDefault();
        }
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
        this.isNavigationCollapse = true;
    }

    subItemOnClick(event, item) {
        // prevent a.href auto redirect
        this.emptyClick(event);
        this._cleanPageInfo(item.routerLink);
        this._router.navigate([item.routerLink]);
        this._setSelectedMenu(item.type);
        this.isNavigationCollapse = true;
    }

    menuOnMouseOver(event) {
        this.isNavigationCollapse = false;
    }

    menuOnItemOver(event, menu) {
        clearTimeout(this._delayDismiss);
        this._delayDismiss = setTimeout(() => {
            this.hoverMenu = menu.id;
        }, MENU_TOLERANCE);
        this.isNavigationCollapse = false;
    }

    menuOnMouseOut(event) {
        if (this._delayDismiss) {
            clearTimeout(this._delayDismiss);
        }
        this.hoverMenu = null;
        this.isNavigationCollapse = true;
    }

    // when user click the add research view/dashboard on submenu on pc
    onClickCreateItem(item) {
        if (item.type === 'dashboard') {
            this._DashboardDialogService.open();
        } else if (item.type === 'workflow') {
            this._workflowDialogService.open();
        } else {
            this._saveScreenDialogService.open({
                operation: SaveScreenDialogOperations.CREATE,
                type: SaveScreenDialogType.RESEARCH_VIEW,
                data: this._generateNewResearchViewInfo(),
                invoker: SaveScreenDialogInvoker.CREATE_RESEARCH
            });
        }
        this.isNavigationCollapse = true;
    }

    onHandleConfigFileInput(event) {
        this._workflowDialogService.openFileBrowserDialog(event);
    }

    onImportConfigFile(item) {
        if (item.type === 'workflow') {
            document.getElementById('file-selector').click();
            document.getElementById('file-selector').addEventListener('change', this.onHandleConfigFileInput.bind(this));
        }
    }

    settingsOnMouseOver(event) {
        this.isNavigationCollapse = false;
    }

    settingsOnMouseOut(event) {
        this.isNavigationCollapse = true;
    }

    trackByFn(index, item) {
        return item.id;
    }

    // change livewire name
    private _changeLivewireName(value) {
        this.isLivewireDataReady = true;
        if (!value) {
            this.currentLivewireName = 'Livewire';
        } else {
            this.currentLivewireName = value;
        }
        this.navigationMenuContainer.forEach(menu => {
            if (menu.type === 'feeds') {
                menu.items[0].caption = this.currentLivewireName;
            }
        });
    }

    private _createNavigationMenu() {
        // get navigation menu status from global config
        const systemConfig = this._storeQuerierService.queryBySelector('systemConfig');
        const isHideWorkflow = !systemConfig.workflow.enable;
        this.hideIntralinks = !systemConfig.intralinks.enable;
        // Mobile client hide create dashboard. Only ppc user show create dashboard
        const canAddAndHideIpad = this._isPublishPubConfiguration && !this.isIPAD;
        const canCreateResearchView = !this.isIPAD;
        this.navigationMenuContainer = [
            new NavigationMenu('01', 'Home', businessConstants.screenType.home,
                { name: 'home', style: 'home' }, 'home', null, 'navigator_home'),
            new NavigationMenu('02', 'Research', businessConstants.screenType.research,
                { name: 'research', style: 'research' }, null, null, 'navigator_research', canCreateResearchView),
            new NavigationMenu('03', 'Dashboard', businessConstants.screenType.dashboard,
                { name: 'dashboard', style: 'dashboards' }, null, null, 'navigator_dashboards', canAddAndHideIpad),
            new NavigationMenu('04', 'Feeds', businessConstants.screenType.livewire, { name: 'feeds', style: 'feeds' }, '',
                [
                    {
                        id: 'blastemail',
                        caption: this.currentLivewireName,
                        type: businessConstants.screenType.livewire,
                        icon: { name: 'livewire', style: '' },
                        routerLink: 'feeds/livewire',
                        items: null,
                        tid: '',
                        canAdd: false,
                        useWidget: false,
                        hide: false
                    },
                    Object.assign({}, businessConstants.intralinkScreen.menuOption, { hide: this.hideIntralinks })
                ], 'navigator_feeds', false),
        ];
        if (this._showAudit) {
            this.navigationMenuContainer.push(new NavigationMenu('08', 'Audit Log', businessConstants.screenType.auditLog,
                { name: 'audit', style: 'auditlog' }, null, null, 'navigator_auditlog', false));
        }

        this.navigationMenuContainer.push(new NavigationMenu('05', 'Entities', businessConstants.screenType.entity,
            { name: 'entity', style: 'entities' }, 'entities', null, 'navigator_entities'));
        this.navigationMenuContainer.push(new NavigationMenu('06', 'Contacts', businessConstants.screenType.contact,
            { name: 'users-o', style: 'contacts' }, 'contacts', null, 'navigator_contacts'));
        this.navigationMenuContainer.push(new NavigationMenu('07', 'Calendar', businessConstants.screenType.event,
            { name: 'calendar', style: 'calendar' }, null, null, 'navigator_calendar', false));
        this.navigationMenuContainer.push(new NavigationMenu('09', 'Email Digest', businessConstants.screenType.emailDigest,
            { name: 'email', style: 'email-digest' }, 'email-digest', null, 'navigator_email_digest'));
        this.navigationMenuContainer.push(new NavigationMenu('10', 'Workflow', businessConstants.screenType.workflow,
            { name: 'workflow', style: 'workflow' }, null, null, 'navigator_workflow', this.canCreateWorkflow, false, isHideWorkflow));
    }

    private _generateNewResearchViewInfo() {
        const researchViewInfo = new ResearchViewInfo();
        const currentContact = this._storeQuerierService.queryBySelector(systemCurrentContactSelector);
        researchViewInfo.finderInfo = {
            entityId: currentContact.id,
            status: ResearchFocusStatus.ALL
        };
        researchViewInfo.relationshipTreeInfo = {
            showAs: 'shortName',
            checkedNodeKeys: []
        };
        return researchViewInfo;
    }

    private _loadMoreData(screenList) {
        const researchFixSubItems = [];
        let researchSubItems = [];
        const dashboardSubItems = [];
        const workflowSubItems = [];
        const auditLogFixSubItems = [];
        const eventFixSubItems = [];
        const intralinkSubSubItems = [];
        let eventSubItems = [];
        let auditLogSubItems = [];
        // add fixed research page
        researchFixSubItems.push({
            id: businessConstants.allNotesScreenId,
            caption: businessConstants.allNotesCaption,
            type: businessConstants.screenType.research,
            icon: { name: '', style: '' },
            routerLink: 'research/' + businessConstants.allNotesScreenId,
            items: null
        });
        researchFixSubItems.push({
            id: businessConstants.myNotesScreenId, caption: businessConstants.myNotesCaption,
            type: businessConstants.screenType.research, icon: { name: '', style: '' },
            routerLink: 'research/' + businessConstants.myNotesScreenId, items: null
        });
        // add fixed audit log page
        auditLogFixSubItems.push({
            id: businessConstants.auditLog.Id,
            caption: businessConstants.auditLog.Caption,
            type: businessConstants.screenType.auditLog,
            icon: { name: '', style: '' },
            routerLink: 'auditlog/',
            items: null
        }, {
            id: businessConstants.loginUsageReport.Id,
            caption: businessConstants.loginUsageReport.Caption,
            type: businessConstants.screenType.auditLog,
            icon: { name: '', style: '' },
            routerLink: 'usagereport/',
            items: null
        });
        // add fixed event page
        eventFixSubItems.push({
            id: businessConstants.eventScreen.eventScreenId,
            caption: businessConstants.eventScreen.allEventsCaption,
            type: businessConstants.screenType.event,
            icon: { name: '', style: '' },
            routerLink: 'calendar/' + businessConstants.eventScreen.eventScreenId,
            items: null
        });
        // add dynamic page
        if (screenList) {
            screenList.forEach(item => {
                if (item.type === businessConstants.screenType.research) {
                    if (item.id !== businessConstants.allNotesScreenId && item.id !== businessConstants.myNotesScreenId) {
                        researchSubItems.push({
                            id: item.id, caption: item.name, type: businessConstants.screenType.research,
                            icon: { name: '', style: '' }, routerLink: `research/${item.id}`, items: null
                        });
                    }
                } else if (item.type === businessConstants.screenType.dashboard) {
                    dashboardSubItems.push({
                        id: item.id, caption: item.name, type: businessConstants.screenType.dashboard,
                        icon: { name: '', style: '' }, routerLink: `dashboard/${item.id}`, items: null
                    });
                } else if (item.type === businessConstants.screenType.intralink) {
                    intralinkSubSubItems.push({
                        id: item.id, caption: item.name, type: businessConstants.screenType.intralink,
                        icon: null, routerLink: `feeds/intralinks/${item.id}`, items: null
                    });
                } else if (item.type === businessConstants.screenType.dashboard) {
                    dashboardSubItems.push({
                        id: item.id, caption: item.name, type: businessConstants.screenType.dashboard,
                        icon: { name: '', style: '' }, routerLink: `dashboard/${item.id}`, items: null
                    });
                } else if (item.type === businessConstants.screenType.workflow) {
                    // workflow screen has published, navigete to kanban page; do not publish, navigete workflow config page
                    if (item.configuration.draft && !item.configuration.id) {
                        workflowSubItems.push({
                            id: item.id, caption: item.name, type: businessConstants.screenType.workflow,
                            icon: { name: '', style: '' }, routerLink: `workflow/config/draft/${item.id}`, items: null
                        });
                    } else {
                        workflowSubItems.push({
                            id: item.id, caption: item.name, type: businessConstants.screenType.workflow,
                            icon: { name: '', style: '' }, routerLink: `workflow/kanban/${item.id}/${item.configuration.id}`, items: null
                        });
                    }
                }
            });
        }
        ArrayHelperService.sort(researchSubItems, 'caption');
        ArrayHelperService.sort(dashboardSubItems, 'caption');
        ArrayHelperService.sort(workflowSubItems, 'caption');
        ArrayHelperService.sort(intralinkSubSubItems, 'caption');

        if (this._currentUser && this._currentUser.credential) {
            intralinkSubSubItems.unshift(businessConstants.intralinkScreen.createMenuOption);
        }

        // intralinks - when user has no sub sub item to see, hide the sub item
        if (intralinkSubSubItems.length === 0) {
            const feeds = this.navigationMenuContainer.filter(item => item.caption === 'Feeds');
            if (feeds.length > 0) {
                feeds[0].items.pop();
            }
        }

        researchSubItems = researchFixSubItems.concat(researchSubItems);
        eventSubItems = eventFixSubItems;
        auditLogSubItems = auditLogFixSubItems;
        this.navigationMenuContainer.forEach(menu => {
            if (menu.type === businessConstants.screenType.research) {
                menu.items = researchSubItems;
            } else if (menu.type === businessConstants.screenType.dashboard) {
                menu.items = dashboardSubItems;
            } else if (menu.type === businessConstants.screenType.auditLog) {
                menu.items = auditLogSubItems;
            } else if (menu.type === businessConstants.screenType.event) {
                menu.items = eventSubItems;
            } else if (menu.type === businessConstants.screenType.livewire) {
                menu.items.forEach(submenu => {
                    if (submenu.id === businessConstants.intralinkScreen.menuOption.id) {
                        submenu.items = intralinkSubSubItems;
                    }
                });
            } else if (menu.type === businessConstants.screenType.workflow) {
                menu.items = workflowSubItems;
            }
        });
        this.isNavigationDataReady = true;
    }

    // select the menu when user click the menu
    private _setSelectedMenu(item: any) {
        if (item) {
            // this condition is for loading page first
            this.selectedMenu = item;
            return;
        } else {
            this.selectedMenu = 'home';
        }
    }

    private _cleanPageInfo(link: string) {
        let realURL = this._router.url;
        while (realURL.startsWith('/')) {
            realURL = realURL.substring(1);
        }
        if (link !== realURL) {
            this._store.dispatch({
                type: ScreenActionTypes.SET_VALUE,
                payload: {
                    url: '',
                    name: '',
                    type: ''
                }
            });
        }
    }

    private _mapUrl2SelectedMenu(url: string) {
        const routes = url.split('/');
        const root = routes[0].length > 0 ? routes[0] : routes[1];
        let found = false;
        this.navigationMenuContainer.forEach(menuItem => {
            if (
                (menuItem.routerLink && menuItem.routerLink.length > 0 && root === menuItem.routerLink) ||
                (menuItem.items && menuItem.items.length > 0 && menuItem.items[0].routerLink.includes(root))
            ) {
                this.selectedMenu = menuItem.type;
                found = true;
            }
        });
        if (!found) {
            this.selectedMenu = root;
        }
    }

    private _onIntralinksConfigChange(intralinks: IntralinksSetting, isOnlyEnable: boolean) {
        if (this.navigationMenuContainer && this.navigationMenuContainer.length > 4) {
            this.navigationMenuContainer[3].items[1].hide = !intralinks.enable;
        }

        const notice = new NotificationOptions();
        notice.style = NotificationStyles.Success;
        if (isOnlyEnable) {
            notice.message = 'Intralinks icon on menu is ' + (!intralinks.enable ? 'hidden' : 'shown') + ' successfully';
        } else {
            notice.message = 'IntraLinks integration settings saved successfully.';
        }
        this._toastService.notify(notice);
    }

    private _onWorkflowConfigChange(workflow: { enable: boolean }) {
        const value = !workflow.enable;
        const workflowMenu = this.navigationMenuContainer.find(menu => menu.type === 'workflow');
        if (workflowMenu.hide !== value) {
            workflowMenu.hide = value;

            const notice = new NotificationOptions();
            notice.style = NotificationStyles.Success;
            notice.message = `Workflow feature is ${value ? 'disabled' : 'enabled'} successfully`;
            this._toastService.notify(notice);
        }
    }
}
